import StudentsFreeItem from './students-free-item'

export default StudentsFreeItem
